import { FindAllAgecStatsQueryParams, useFindAllAgecStats } from "~/gen/api"

export const useFindAllAgecStatsQuery = (params: FindAllAgecStatsQueryParams) =>
  useFindAllAgecStats(params)
